import script from "./presetsMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./presetsMenu.vue?vue&type=script&setup=true&lang=js"

import "@vueform/toggle/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./presetsMenu.vue?vue&type=style&index=1&id=b4611aea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4611aea"]])

export default __exports__